import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  endOfList: {
    textAlign: 'center',
    padding: '1rem',
    color: '#888',
    fontSize: '0.875rem',
  },
  sortableColumn: {
    display: 'flex',
  },
  header: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    marginBottom: '8px',
  },
})

export default useStyles
